/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageInfoDto } from '../../models/page-info-dto';
import { SettlementDto } from '../../models/settlement-dto';

export interface SettlementControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 특정 회원 ID (해당 회원의 정산 내역만 조회)
 */
  userId?: string;

/**
 * 정산 상태
 */
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED';

/**
 * 시작일 (Exit 일자 기준)
 */
  startDate?: string;

/**
 * 종료일 (Exit 일자 기준)
 */
  endDate?: string;
}

export function settlementControllerSearch(http: HttpClient, rootUrl: string, params: SettlementControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<SettlementDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('userId', params.userId, {});
    rb.query('status', params.status, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<SettlementDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

settlementControllerSearch.PATH = '/api/settlement/search/offset';
